import { pickBy, identity } from 'lodash';
import { TextStyle_TextAlignment } from 'ricos-schema';
import { LINK_PREVIEW_TYPE, EMBED_TYPE, COLLAPSIBLE_LIST_TYPE, TABLE_TYPE, DIVIDER_TYPE, NO_WRAP } from '../../../consts.js';
import { generateId } from '../../generateRandomId.js';
import { TO_RICOS_DATA_FIELD, TO_RICOS_PLUGIN_TYPE } from '../consts.js';
import { convertBlockDataToRicos } from './convertRicosPluginData.js';
import '../../../utils.js';
import '../../../index-205daf5f.js';
import '../../../file-size-utils/to-size-in-kb.js';
import '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import '../../../string-40bcd6bf.js';
import 'uuid';
import '../utils.js';
import './consts.js';
import './convertJsonToStruct.js';
import '../../../Either-48abb652.js';
import '../../../Record-7477f278.js';
import '../../../ReadonlyRecord-86a56753.js';
import '../../../Tuple-2f69c1c7.js';
import '../../../fp-utils-24a5cc96.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const supportedTextAlignments = [
  TextStyle_TextAlignment.AUTO,
  TextStyle_TextAlignment.LEFT,
  TextStyle_TextAlignment.RIGHT,
  TextStyle_TextAlignment.CENTER,
  TextStyle_TextAlignment.JUSTIFY
];
const normalizeBlockData = (type, data) => {
  switch (type) {
    case DIVIDER_TYPE: {
      data.config = data.config || { textWrap: NO_WRAP };
      return;
    }
    case TABLE_TYPE: {
      data.config.rows = Object.keys(data.config.rows).reduce((acc, key) => {
        const row = data.config.rows[key];
        acc[key] = __spreadProps(__spreadValues({}, row), {
          columns: row.columns || {
            0: {
              content: {
                blocks: [
                  {
                    key: generateId(),
                    text: "",
                    type: "unstyled",
                    depth: 0,
                    inlineStyleRanges: [],
                    entityRanges: [],
                    data: {}
                  }
                ]
              }
            }
          }
        });
        return acc;
      }, {});
      return;
    }
  }
};
const getEntity = (key, entityMap) => {
  var _a;
  if (!entityMap[key]) {
    console.error(`Invalid entity key '${key}' -- entry does not exist.`);
    return null;
  }
  const { type, data } = entityMap[key];
  const blockType = type === LINK_PREVIEW_TYPE && data.html ? EMBED_TYPE : type;
  const dataFieldName = TO_RICOS_DATA_FIELD[blockType];
  if (dataFieldName === void 0) {
    console.error(`Unknown entity type "${blockType}"!`);
    return null;
  }
  if (!data) {
    console.error(`no data for "${blockType}"!`);
    return null;
  }
  normalizeBlockData(type, data);
  const advancedPluginsAdditionalData = {
    [COLLAPSIBLE_LIST_TYPE]: { pairs: data == null ? void 0 : data.pairs },
    [TABLE_TYPE]: { rows: (_a = data == null ? void 0 : data.config) == null ? void 0 : _a.rows }
  };
  return __spreadValues({
    type: TO_RICOS_PLUGIN_TYPE[blockType],
    [dataFieldName]: convertBlockDataToRicos(blockType, data)
  }, advancedPluginsAdditionalData[blockType] || {});
};
const getTextStyle = (blockData) => {
  const { textAlignment, dynamicStyles } = blockData || {};
  const { "line-height": lineHeight } = dynamicStyles || {};
  const normalizedTextAlignment = textAlignment == null ? void 0 : textAlignment.toUpperCase();
  return {
    textAlignment: normalizedTextAlignment && supportedTextAlignments.includes(normalizedTextAlignment) ? normalizedTextAlignment : null,
    lineHeight
  };
};
const getNodeStyle = (blockData) => {
  const { dynamicStyles } = blockData || {};
  const {
    "padding-top": paddingTop,
    "padding-bottom": paddingBottom,
    backgroundColor
  } = dynamicStyles || {};
  const style = pickBy({ paddingTop, paddingBottom, backgroundColor }, identity);
  const hasStyle = Object.values(style).length > 0;
  return hasStyle ? style : void 0;
};

export { getEntity, getNodeStyle, getTextStyle };
//# sourceMappingURL=getRicosEntityData.js.map
